import React from 'react';
import './../styles/HR.css';

const HR = () => {
  return <hr className="custom-hr" />;
};

export default HR;